module.exports = __webpack_public_path__ + "static/media/notification-icon.2efb4456.svg";